import React from "react";
import { authContext } from "./context";

export function useAuth() {
  return React.useContext(authContext);
}
